import { render, staticRenderFns } from "./PopUpCustomWidth.vue?vue&type=template&id=04fde846&"
import script from "./PopUpCustomWidth.vue?vue&type=script&lang=js&"
export * from "./PopUpCustomWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports